// 引入数据配置文件
import FormConfig from "./formConfig.js";
import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,

      // 操作类型
      controllerFlg: null, // 操作标志
      // 主键
      id: null, // 主键
      // 表单配置
      formConfigList: FormConfig.configList(),
      /*********************************招标机构组织人员************************************** */
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        isReleasePlannedTender: null, // 招标计划是否发布
        isRestrictAnnouncement: null, // 是否限制公告发布
        plannedTenderTime: null, // 计划招标时间
        taskPlan: null, // 工作任务计划
      },
      // 表格基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "工作单位",
          prop: "corpName",
        },
        {
          label: "职务",
          prop: "duty",
        },
        {
          label: "专业技术职称",
          prop: "proTitle",
        },
        {
          label: "负责招标工作具体内容",
          prop: "tendererMark",
        },
      ],
      // 表格数据
      tableData: [],
      /*********************************房屋建筑单体工程明细************************************** */
      // 列表loading状态
      buildingMonomerLoading: false,
      // 表单对象
      buildingMonomerForm: {
      },
      // 表格基础数据
      buildingMonomerTableColumns: [
        {
          label: "名称",
          prop: "name",
        }, 
        {
          label: "单体编号",
          prop: "buildingNum",
        }, 
        {
          label: "图纸栋号",
          prop: "drawingNum",
        }, 
        {
          label: "地下建筑面积",
          prop: "ugFloorArea",
        }, 
        {
          label: "地上建筑面积",
          prop: "agFloorArea",
        }, 
        {
          label: "地下层数",
          prop: "ugFloorLayer",
        }, 
        {
          label: "地上层数",
          prop: "agFloorLayer",
        }, 
        {
          label: "是否经济适用房",
          prop: "isEconomical",
        }, 
        {
          label: "所属标段",
          prop: "section",
        }, 
        {
          label: "单体估价",
          prop: "appraisal",
        },
      ],
      // 表格数据
      buildingMonomerTableData: [],
      /*********************************市政基础设施工程明细************************************** */
      // 列表loading状态
      municipalLoading: false,
      // 表单对象
      municipalForm: {},
      // 表格基础数据
      municipalTableColumns: [
        {
          label: "管理部门",
          prop: "competentDepartName",
        }, 
        {
          label: "工程大类",
          prop: "prjLargeClass",
        }, 
        {
          label: "工程小类",
          prop: "prjCategory",
        }, 
        {
          label: "等级指标名称",
          prop: "levelName",
        }, 
        {
          label: "等级指标数量",
          prop: "levelQuantity",
        }, 
        {
          label: "等级指标单位",
          prop: "levelUnit",
        }, 
        {
          label: "规模指标名称",
          prop: "prjSize",
        }, 
        {
          label: "规模指标数量",
          prop: "prjSizeQuantity",
        }, 
        {
          label: "规模指标单位",
          prop: "prjSizeUnit",
        }, 
        {
          label: "所属标段",
          prop: "section",
        }, 
        {
          label: "标段说明",
          prop: "sectionMark",
        },
      ],
      // 表格数据
      municipalTableData: [],
      /*********************************材料设备采购明细************************************** */
      // 列表loading状态
      equipmentLoading: false,
      // 表单对象
      equipmentForm: {},
      // 表格基础数据
      equipmentTableColumns: [
        {
          label: "货物名称",
          prop: "goodsName",
        }, 
        {
          label: "规格型号",
          prop: "specificationModel",
        },
        {
          label: "数量",
          prop: "quantity",
        }, 
        {
          label: "单位",
          prop: "unit",
        },
      ],
      // 表格数据
      equipmentTableData: [],
    };
  },
  // 接收来自父组件的数据
  props: {
    // 用于判断是否为子组件
    isComponent: {
      type: Boolean,
      default: false
    },
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open() {
      // 招标机构组织人员
      this.fun_GetTendererOrganizationList();
      // 房屋建筑单体工程明细
      this.fun_GetTendererBuildingMonomerList();
      // 市政基础设施工程明细表
      this.fun_GetTendererMunicipalList();
      // 材料设备采购明细
      this.fun_GetTendererEquipmentList();
    },
    /**
    * 招标机构组织人员
    * @author 付翔
    */
    fun_GetTendererOrganizationList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction("/tenderRegistration/tendererOrganizationList", {
          registrationId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.loading = false;
            // 回显table
            this.tableData = data;
          } else {
            // 关闭loading
            this.loading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
    * 房屋建筑单体工程明细
    * @author 付翔
    */
    fun_GetTendererBuildingMonomerList() {
      try {
        // 打开loading
        this.buildingMonomerLoading = true;
        // 请求，获取结果集
        fun_PostAction("/tenderRegistration/tendererBuildingMonomerList", {
          registrationId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.buildingMonomerLoading = false;
            // 回显table
            this.buildingMonomerTableData = data;
          } else {
            // 关闭loading
            this.buildingMonomerLoading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.buildingMonomerLoading = false;
      }
    },
    /**
    * 市政基础设施工程明细
    * @author 付翔
    */
    fun_GetTendererMunicipalList() {
      try {
        // 打开loading
        this.municipalLoading = true;
        // 请求，获取结果集
        fun_PostAction("/tenderRegistration/tendererMunicipalList", {
          registrationId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.municipalLoading = false;
            // 回显table
            this.municipalTableData = data;
          } else {
            // 关闭loading
            this.municipalLoading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.municipalLoading = false;
      }
    },
    /**
    * 材料设备采购明细
    * @author 付翔
    */
    fun_GetTendererEquipmentList() {
      try {
        // 打开loading
        this.equipmentLoading = true;
        // 请求，获取结果集
        fun_PostAction("/tenderRegistration/tendererEquipmentList", {
          registrationId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.equipmentLoading = false;
            // 回显table
            this.equipmentTableData = data;
          } else {
            // 关闭loading
            this.equipmentLoading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.equipmentLoading = false;
      }
    },
  }
};
